import { Injectable } from "@angular/core";
import { HttpContext } from "@angular/common/http";

import { Package, PackagePayload } from "src/app/features/admin/interfaces";
import { GetPagedBody, HttpService, HttpServiceBaseCRUD } from "src/app/core";

@Injectable({
  providedIn: "root",
})
export class PackagesService extends HttpService implements HttpServiceBaseCRUD {
  protected override get baseUrl(): string {
    return "packages/";
  }

  add(body: PackagePayload) {
    return this.post<Package>({ APIName: "add", body, showAlert: true });
  }

  update(body: PackagePayload) {
    return this.put<Package>({ APIName: "update", body, showAlert: true });
  }

  remove(id: string) {
    return this.delete<boolean>({ APIName: `deletesoft/${id}`, showAlert: true });
  }

  getById(id: string) {
    return this.get<Package>({ APIName: `get-id/${id}` });
  }

  getPaged(body: GetPagedBody<Package>) {
    return this.getPagedRequest<Package[]>({ APIName: "getpaged", body });
  }

  getAll(context?: HttpContext) {
    return this.get<Package[]>({ APIName: "getall", context });
  }
}
